import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

class Sidebar extends Component {

  state = {};

  toggleMenuState(menuState) {
    if (this.state[menuState]) {
      this.setState({[menuState] : false});
    } else if(Object.keys(this.state).length === 0) {
      this.setState({[menuState] : true});
    } else {
      Object.keys(this.state).forEach(i => {
        this.setState({[i]: false});
      });
      this.setState({[menuState] : true});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    document.querySelector('#sidebar').classList.remove('active');
    Object.keys(this.state).forEach(i => {
      this.setState({[i]: false});
    });

  
 
  }

  render () {
    return (
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
        <li className={ this.isPathActive('/dashboard') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/dashboard">
              <i className="mdi mdi-grid-large menu-icon"></i>
              <span className="menu-title">Dashboard</span>
            </Link>
          </li>
          <li className={ this.isPathActive('/asset') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/asset">
              <i className="mdi mdi-wrench  menu-icon"></i>
              <span className="menu-title">Asset Management</span>
            </Link>
          </li>

          <li className={ this.isPathActive('/move') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/move">
              <i className="mdi mdi-priority-high  menu-icon"></i>
              <span className="menu-title">Relocate Assets</span>
            </Link>
          </li>

          <li className={ this.isPathActive('/checklist') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/checklist">
              <i className="mdi mdi-playlist-check menu-icon"></i>
              <span className="menu-title">Checklist Library</span>
            </Link>
          </li>
          <li className={ this.isPathActive('/documents') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/documents">
              <i className="mdi mdi-file-document menu-icon"></i>
              <span className="menu-title">Document Library</span>
            </Link>
          </li>
          <li className={ this.isPathActive('/users') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/users">
              <i className="mdi mdi-account-multiple menu-icon"></i>
              <span className="menu-title">User Management</span>
            </Link>
          </li>

          <li className={ this.isPathActive('/logout') ? 'nav-item active' : 'nav-item' }>
            <Link className="nav-link" to="/logout">
              <i className="mdi mdi-power menu-icon"></i>
              <span className="menu-title">Logout</span>
            </Link>
          </li>

          

        </ul>
      </nav>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }

  componentDidMount() {
    this.onRouteChanged();
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    const body = document.querySelector('body');
    document.querySelectorAll('.sidebar .nav-item').forEach((el) => {
      
      el.addEventListener('mouseover', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function() {
        if(body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });
  }

}

export default withRouter(Sidebar);